import { useContext } from "react";
import { HarvestContext } from "../../../store/HarvestContext";

type AvailableProductsListProps = {
  onProductUpdate: (productName: string, productAmount: string) => void;
};

const AvailableProductsList = ({
  onProductUpdate,
}: AvailableProductsListProps) => {
  const { harvestProducts } = useContext(HarvestContext);
  const availableProducts = harvestProducts.filter((product) => {
    return Math.max(0, product.quantity) > 0;
  });
  const productListItems = availableProducts.map((product) => {
    const availableQuantity = Math.max(0, product.quantity);
    const discountedPrice = product.discount
      ? Math.round(product.price * (1 - product.discount / 100) * 10) / 10
      : null;
    return (
      <li className="produce-list-item" key={product.id}>
        <div className="produce-item-heading">
          <h3 className="product-heading">
            {product.name} ({availableQuantity} kg)
          </h3>
          {discountedPrice ? (
            <p>
              <span className={discountedPrice ? "old-price price" : "price"}>
                {product.price} kr
              </span>
              /kg{" "}
              <span className="sales-tag beige-tag">
                {discountedPrice} kr/kg
              </span>
            </p>
          ) : (
            <p>
              <span className="price">{product.price} kr</span>/kg
            </p>
          )}
        </div>
        <div className="business-product-input">
          <label htmlFor="quantity" className="sr-only">
            Quantity
          </label>
          <input
            className="product-quantity-input"
            type="number"
            id="quantity"
            placeholder="kg"
            min={0}
            onChange={(e) => onProductUpdate(product.name, e.target.value)}
          />
        </div>
      </li>
    );
  });

  return <ul>{productListItems}</ul>;
};

export default AvailableProductsList;
